import styled from 'styled-components'
import { breakpoint } from 'utils'

export const SectionElement = styled.section`
  color: ${({ theme }) => theme.colors.foreground.secondary[3]};

  font-size: ${({ theme }) => theme.fontSizes.small};
  line-height: 1.4;
`

export const Title = styled.h1`
  margin: 0 0 4px;

  color: ${({ theme }) => theme.colors.foreground.secondary[1]};

  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.6;
`

export const TextAndButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  margin-bottom: 16px;

  ${breakpoint('sm')`
    flex-direction: row;
  `}
`

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0 0;

  ${breakpoint('sm')`
    margin: 0 0 0 16px;
  `}
`
